import { Injectable } from '@angular/core';
import { Query } from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable({
  providedIn: 'root'
})
export class QueryLocationsGroupsPaginatedGQL extends Query<any> {
  document = gql`
    query locationsGroups (
      $where: LocationGroupWhereInput,
      $orderBy: LocationGroupOrderByInput,
      $limit: Int,
      $offset: Int
    ) {
      locationsGroups(where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {
        totalCount
        items {
          id
          name
          archived
          createdAt
          description
        }
      }
    }
  `;
}

@Injectable({
  providedIn: 'root'
})
export class QueryLocationGroupGQL extends Query<any> {
  document = gql`
    query queryLocationGroup (
      $id: ID!
    ) {
      locationGroup(id: $id) {
        id
        name
        archived
        description
      }
    }
  `;
}
